/*
 * Локальная "тема" amCharts4, которая включает встроенный Responsive-плагин
 * для каждого графика (Chart). Без правки 24 chart-компонентов по отдельности.
 *
 * В amCharts4 4.10 пакет не поставляет themes/responsive.js, но класс
 * Responsive есть в core — он создаётся для каждого Chart в свойстве
 * chart.responsive. Достаточно включить его и использовать дефолтные правила.
 *
 * useDefault = true: набор стандартных правил (скрытие легенды, уменьшение
 * подписей и т.п.) когда Chart pixelWidth становится узким. На широких
 * графиках поведение не меняется.
 */
export default function am4themes_responsive(target) {
  if (
    target &&
    target.responsive &&
    typeof target.responsive.enabled !== "undefined"
  ) {
    target.responsive.enabled = true;
    target.responsive.useDefault = true;
  }
}
